
import { Component } from '@niknevis/vue-modules'
import AdminCouponBaseForm from '@/modules/coupon/components/admin/base/AdminCouponBaseForm.vue'
import { AdminUpdateCouponUseCase } from '@/modules/coupon/use-cases/admin-update-coupon.use-case'
import { Prop } from 'vue-property-decorator'
import { CouponResourceModel } from '@/modules/coupon/models/coupon-resource.model'
import { CouponRequestModel } from '@/modules/coupon/models/coupon-request.model'

@Component
export default class AdminCouponEditForm extends AdminCouponBaseForm {
  constructor(
    private readonly useCase: AdminUpdateCouponUseCase
  ) {
    super()
  }

  @Prop({ required: true }) couponResource: CouponResourceModel

  protected __codeInputDisability: boolean = true

  protected __typeInputDisability: boolean = true

  protected __amountInputDisability: boolean = true

  protected requestData: CouponRequestModel = {
    amount: this.couponResource.amount,
    code: this.couponResource.code,
    expired_at: this.couponResource.expired_at,
    item_quantity_limit: this.couponResource.item_quantity_limit,
    prohibited_services: this.couponResource.prohibited_services,
    required_services: this.couponResource.required_services,
    status: this.couponResource.status,
    title: this.couponResource.title,
    type: this.couponResource.type,
    usage_count_limit: this.couponResource.usage_count_limit,
    user_usage_limit: this.couponResource.user_usage_limit,
    users: this.couponResource.users,
    special_offer: this.couponResource.special_offer,
    instructions: this.couponResource.instructions,
    discount_unit: this.couponResource.discount_unit,
    minimum_number_purchase: this.couponResource.minimum_number_purchase,
    maximum_discount: this.couponResource.maximum_discount
  }

  protected prohibitedServiceSearchDefault: number[] = this.requestData.prohibited_services

  protected requiredServiceSearchDefault: number[] = this.requestData.required_services

  protected userSearchDefault: number[] = this.requestData.users

  protected get loadingState(): boolean {
    return this.loading || this.__loadingState || this.useCase.isLoading
  }

  protected onSubmit() {
    this.useCase.execute(this.couponResource.id, this.requestData)
  }
}
